import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  I18n,
  Status,
  Preloader,
} from 'components';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const UpdatingStatus = ({
  isUpdating,
  success,
  error,
  successMessage,
  errorMessage,
  className,
}) => {
  if (isUpdating) {
    return (
      <div className={cx('wrapper', className)}>
        <Preloader
          className={cx('spinner')}
          size="35"
        />
        <I18n
          path="common.pleaseWait"
          className={cx('spinnerText')}
        />
      </div>
    );
  }

  if (success) {
    return (
      <div className={cx('wrapper', className)}>
        <Status className="success">
          <I18n path={successMessage} />
        </Status>
      </div>
    );
  }

  if (error) {
    return (
      <div className={cx('wrapper', className)}>
        <Status
          className="error"
          emoji="statusFail"
        >
          <I18n path={errorMessage} />
        </Status>
      </div>
    );
  }

  return null;
};

UpdatingStatus.propTypes = {
  isUpdating: PropTypes.bool,
  success: PropTypes.bool,
  error: PropTypes.any,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
};

export default UpdatingStatus;
